import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const RegistrationHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="text-center space-y-6">
      {/* Logo */}
      <div 
        className="flex items-center justify-center cursor-pointer hover-lift"
        onClick={() => navigate('/marketing-home')}
      >
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
            <svg 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              className="text-primary-foreground"
            >
              <path 
                d="M3 3h18v18H3V3zm2 2v14h14V5H5zm2 2h10v2H7V7zm0 4h10v2H7v-2zm0 4h6v2H7v-2z" 
                fill="currentColor"
              />
            </svg>
          </div>
          <span className="text-2xl font-bold text-foreground font-inter">
            BPMLflows
          </span>
        </div>
      </div>

      {/* Header Content */}
      <div className="space-y-3">
        <h1 className="text-3xl font-bold text-foreground font-inter">
          Create Your Account
        </h1>
        <p className="text-lg text-muted-foreground max-w-md mx-auto">
          Join thousands of SAP professionals streamlining their implementation workflows
        </p>
      </div>

      {/* Benefits */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm">
        <div className="flex items-center justify-center space-x-2 text-muted-foreground">
          <Icon name="Shield" size={16} className="text-success" />
          <span>Enterprise Security</span>
        </div>
        <div className="flex items-center justify-center space-x-2 text-muted-foreground">
          <Icon name="Zap" size={16} className="text-warning" />
          <span>Instant Setup</span>
        </div>
        <div className="flex items-center justify-center space-x-2 text-muted-foreground">
          <Icon name="Users" size={16} className="text-primary" />
          <span>Team Collaboration</span>
        </div>
      </div>
    </div>
  );
};

export default RegistrationHeader;